module.exports = __webpack_public_path__ + "fonts/lato-regular-greek.ac0f153.woff";